import { Link } from "react-router-dom";
import useAutoLogout from "../../hooks/useAutoLogout";

export default function AutoLogoutWrapper({ children }) {
    const { expired, handleLoginRedirect } = useAutoLogout();

    if (expired) {
        return (
            <div style={styles.container}>
                <h2 style={styles.title}>Session Expired</h2>
                <p style={styles.text}>Please login again to continue.</p>
                <Link to="/login" style={styles.link} onClick={handleLoginRedirect}>
                    Return to Login
                </Link>
            </div>
        );
    }

    return children;
}

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f8f9fa",
    },
    title: {
        fontSize: "2rem",
        marginBottom: "10px",
        color: "#dc3545",
    },
    text: {
        fontSize: "1.1rem",
        marginBottom: "20px",
    },
    link: {
        textDecoration: "none",
        color: "#007bff",
        fontWeight: "bold",
    },
};
